module.exports = __webpack_public_path__ + "img/arrow-narrow-up-left.fc503045.svg";